import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ForumPost } from "../../../../components/Student/Forum";
import { Post as PostController } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { socket } from "../../../../utils";
import "./Post.scss";

const postController = new PostController();

export function Post() {
  const { accessToken } = useAuth();
  const { postId } = useParams();
  const [post, setPost] = useState({});
  const [reload, setReload] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await postController.getPostById(accessToken, postId);
        setPost(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [postId, accessToken, reload]);

  useEffect(() => {
    const handleForumUpdate = (payload) => {
      if (String(payload.postId) === String(postId)) {
        setReload((prevState) => !prevState);
      }
    };
    socket.on("forumUpdate", handleForumUpdate);
    return () => {
      socket.off("forumUpdate", handleForumUpdate);
    };
  }, [postId]);

  useEffect(() => {
    const handleAnswerCreated = ({ answer, postId: newPostId }) => {
      if (String(newPostId) !== String(postId)) return;
      if (answer.status !== 1) return; // el estudiante solo ve respuestas aprobadas
      setPost((prev) =>
        prev?.id ? { ...prev, Answers: [...(prev.Answers || []), answer] } : prev
      );
    };
    socket.on("answerCreated", handleAnswerCreated);
    return () => {
      socket.off("answerCreated", handleAnswerCreated);
    };
  }, [postId]);

  return (
    <div className="student-post">
      <ForumPost post={post} isPage={true}  />
    </div>
  );
}
